var canvas: HTMLCanvasElement;
var context: CanvasRenderingContext2D;

// game variables
var size = 100;
var world: boolean[][];

var pause = false;

// system variables
var last_tick_t = 0;
var width: number;
var height: number;
var keyStates: Set<string> = new Set();

function initializeWorld() {
    world = [];
    for(let x=0; x<size; x++) {
        world[x] = [];
        for(let y=0; y<size; y++) {
            world[x][y] = Math.random() > 0.6;
        }
    }
}

function draw() {
    context.resetTransform();
    context.clearRect(0, 0, width, height);
    // select color
    context.fillStyle = "green"

    // draw polygon/path
    for(let x=0; x<size; x++) {
        for(let y=0; y<size; y++) {
            if(world[x][y]) {
                context.fillRect(x*width/size, y*height/size, width/size, height/size);
            }
        }
    }
    context.fillStyle = "black";
    context.scale(5,5);
    context.fillText("press any key to pause", 20, 20)
    context.fillText("press R to reset", 20, 30);
}

function newState(x: number, y: number) {
    let neis = 0;
    for(let i=-1; i<=1; i++) {
        for(let j=-1; j<=1; j++) {
            if(world[(x+i+size)%size][(y+j+size)%size]) {
                neis++;
            }
        }
    }
    if(neis == 3) return true;
    if(neis == 4 && world[x][y]) return true;
    return false;
}

function update(dt: number) {
    // copy wolrd
    let newWorld: boolean[][];
    newWorld = []
    for(let x=0; x<size; x++) {
        newWorld[x] = [];
        for(let y=0; y<size; y++) {
            newWorld[x][y] = newState(x, y);
        }
    }
    world = newWorld;
}

function loop(t_ms: number) {
    // calculate dt
    let dt = t_ms - last_tick_t;
    last_tick_t = t_ms;

    if(!pause) {
        update(dt / 1000); // to seconds
        draw();
    }

    window.requestAnimationFrame(loop);
}

function resized() {
    width = window.innerWidth;
    height = window.innerHeight;
    canvas.width = width;
    canvas.height = height;
}

function key(e: KeyboardEvent) {
    switch (e.type) {
        case "keydown":
            console.log(e.key);
            if(e.key == "r") {
                initializeWorld();
                break;
            }
            keyStates.add(e.key);
            pause = !pause;
            break;
        case "keyup":
            keyStates.delete(e.key);
            break;
        default:
            console.warn("Wut?");
    }
}

function click(e: MouseEvent) {

}

function main() {
    canvas = document.getElementById("canvas") as HTMLCanvasElement;
    context = canvas.getContext("2d")!;
    window.addEventListener("keydown", key);
    window.addEventListener("keyup", key);
    window.addEventListener("resize", resized);
    canvas.addEventListener("click", click);
    resized();
    initializeWorld();

    loop(performance.now());
}


main();